import { useEffect, useState } from "react";
import { BarChart, Bar, XAxis, YAxis, Tooltip, Legend, ResponsiveContainer, CartesianGrid } from "recharts";
import { BarChart3 } from "lucide-react";
import { Card } from "@/components/ui/card";
import api from "@/lib/api";

const TICK = { fontSize: 11, fill: "#94a3b8" };
const TOOLTIP_STYLE = { background: "#0f172a", border: "1px solid #334155", fontSize: 12 };
const LEGEND_STYLE = { fontSize: 12 };
const MARGIN = { top: 8, right: 8, left: -16, bottom: 0 };

function Kpi({ label, value, testId }) {
  return (
    <div className="rounded-lg bg-secondary/40 p-3" data-testid={testId}>
      <div className="text-[11px] text-muted-foreground">{label}</div>
      <div className="font-display font-bold text-xl">{value}</div>
    </div>
  );
}

export function InboundWeeklyStats() {
  const [data, setData] = useState(null);
  useEffect(() => { api.whatsappWeeklyStats(8).then(setData).catch(() => {}); }, []);
  if (!data) return null;
  const t = data.totals;
  return (
    <Card className="p-5 bg-card border-border space-y-3" data-testid="whatsapp-weekly-stats">
      <h3 className="font-display font-bold text-lg flex items-center gap-2"><BarChart3 className="h-4 w-4" /> Messaggi ricevuti · ultime 8 settimane</h3>
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-2">
        <Kpi label="Ricevuti" value={t.inbound} testId="wa-kpi-inbound" />
        <Kpi label="Giocate concorso" value={t.giocate} testId="wa-kpi-plays" />
        <Kpi label="Comandi" value={t.comandi} testId="wa-kpi-commands" />
        <Kpi label="All'agente IA" value={`${t.agente_ia} (${t.ai_share}%)`} testId="wa-kpi-ai" />
      </div>
      <div className="h-52">
        <ResponsiveContainer width="100%" height="100%">
          <BarChart data={data.weeks} margin={MARGIN}>
            <CartesianGrid stroke="rgba(148,163,184,0.15)" vertical={false} />
            <XAxis dataKey="week" tick={TICK} />
            <YAxis allowDecimals={false} tick={TICK} />
            <Tooltip contentStyle={TOOLTIP_STYLE} />
            <Legend wrapperStyle={LEGEND_STYLE} />
            <Bar dataKey="giocate" name="Giocate concorso" stackId="a" fill="#10b981" />
            <Bar dataKey="comandi" name="Comandi (regolamento, ritiro…)" stackId="a" fill="#3b82f6" />
            <Bar dataKey="agente_ia" name="Lasciati all'agente IA" stackId="a" fill="#94a3b8" radius={[4, 4, 0, 0]} />
          </BarChart>
        </ResponsiveContainer>
      </div>
    </Card>
  );
}
